import { useAppSelector } from '@/store/hooks';
import { selectFeatureFlags } from '@/store/slices/feature-flags/selectors';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';
import { EBroadcastTypes, Session, SessionTypesEnum } from '@/types/session.types';

export const useShowGreenroomButton = (session?: Session): boolean => {
  const flags = useAppSelector(selectFeatureFlags);
  const goToGreenroomForAllBroadcastTypesFlagEnabled =
    flags?.[FeatureFlagsEnum.go_to_greenroom_for_all_broadcast_types];

  if (!session) return false;

  const isBroadcast = session.session_type === SessionTypesEnum.broadcast;

  if (!goToGreenroomForAllBroadcastTypesFlagEnabled) {
    const isGreenroomStream = session.broadcast_type === EBroadcastTypes.greenroom;
    return !!(isBroadcast && isGreenroomStream);
  }

  // if it's an on demand but has a timestanmp, then it was once a broadcast session so we need to show the button
  const onDemandWithTimestamp = session.session_type === SessionTypesEnum.onDemand && session.timestamp;
  const shouldHaveGreenroomProducerUrl = !!(isBroadcast || onDemandWithTimestamp);

  return shouldHaveGreenroomProducerUrl;
};
